import { InputLabel, MenuItem, Select, FormHelperText, FormControl } from '@mui/material';
import React from 'react';

const SingleSelect = (props) => {
    const {
        label = '',
        options = [],
        value = '',
        onChange,
        error = false,
        helperText = '',
        disabled = false,
        required = false,
        size = 'small',
        id = 'Select',
        ...otherProps
    } = props;

    return (
        <FormControl
            fullWidth
            size={size}
            error={error}
        >
            <InputLabel
                id={`${id}-label`}
                sx={{
                    transform: 'translate(14px, 8px) scale(1)',
                    '&.Mui-focused, &.MuiFormLabel-filled': {
                        transform: 'translate(14px, -9px) scale(0.75)'
                    }
                }}
            >
                {label}{required && ' *'}
            </InputLabel>
            <Select
                labelId={`${id}-label`}
                id={id}
                value={value}
                label={label}
                onChange={onChange}
                disabled={disabled}
                sx={{
                    '& .MuiSelect-select': {
                        padding: '8.5px 14px'
                    }
                }}
                {...otherProps}
            >
                {options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            {helperText && (
                <FormHelperText error={error}>
                    {helperText}
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default SingleSelect;